<template>
  <div
    v-if="details"
    class="bg-primary-white lg:p-6 p-3.5 border border-primary-gray-200 rounded-lg text-xs md:text-base"
  >
    <div class="py-3 font-inter">
      <div class="flex flex-wrap" :class="customClasses">
        <div v-for="(detail, key, index) in details" :key="index" class="w-full md:w-1/2">
          <div v-if="!excludeKeys.includes(key)" class="flex flex-1 gap-2">
            <div class="shrink-0 pr-2" :style="{ width: keyColumnWidth }">
              <span class="whitespace-nowrap">{{ toPascalCase(key) }}:</span>
            </div>
            <div
              class="text-primary-grey-light flex-1"
              :class="{ capitalize: shouldCapitalize(key) }"
            >
              {{ detail || detail === 0 ? detail : GENERAL_CONSTANTS.NOT_APPLICABLE }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GENERAL_CONSTANTS from '@src/constants/general-constants'
import { toPascalCase } from '@utils/generalUtil'
export default {
  props: {
    excludeKeys: {
      type: Array,
      default: () => ['id'],
    },
    details: {
      type: Object,
      default: () => {},
    },
    customClasses: {
      type: String,
      default: 'md:flex-row flex-col',
    },
  },
  data() {
    return {
      GENERAL_CONSTANTS,
    }
  },
  computed: {
    keyColumnWidth() {
      if (!this.details) return 'auto'
      const keys = Object.keys(this.details).filter((key) => !this.excludeKeys.includes(key))
      if (!keys.length) return 'auto'
      const maxLength = Math.max(...keys.map((key) => this.toPascalCase(key).length))
      return `${maxLength + 1}ch`
    },
  },
  methods: {
    toPascalCase,
    shouldCapitalize(key) {
      return typeof key === 'string' && !key.toLowerCase().includes('email')
    },
  },
}
</script>
